import React from "react";
import { FaUsers, FaGlobe, FaMicrophone, FaLightbulb } from "react-icons/fa";
import { BRAND_COLOR } from "../constants";

const features = [
  {
    icon: <FaUsers size={40} color={BRAND_COLOR} />,
    title: "Community Practice",
    text: "Participate in live group discussions to boost fluency and confidence.",
  },
  {
    icon: <FaGlobe size={40} color={BRAND_COLOR} />,
    title: "Global Connections",
    text: "Connect with learners worldwide and exchange ideas in real-time.",
  },
  {
    icon: <FaMicrophone size={40} color={BRAND_COLOR} />,
    title: "Expert Feedback",
    text: "Receive constructive guidance and personalized feedback from experienced mentors.",
  },
  {
    icon: <FaLightbulb size={40} color={BRAND_COLOR} />,
    title: "Mentor Insights",
    text: "Learn from the real-world experience and practical tips of our mentors.",
  },
];


const FeaturesSection = () => {
  return (
    <section id="features" style={{ padding: "80px 20px", textAlign: "center" }}>
      <h2 style={{ fontSize: "2rem", marginBottom: "40px" }}>Why Choose Us?</h2>
      <div style={{ display: "flex", justifyContent: "center", gap: "40px", flexWrap: "wrap" }}>
        {features.map((feature, i) => (
          <div
            key={i}
            style={{
              width: "280px",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              background: "white",
            }}
          >
            {feature.icon}
            <h3>{feature.title}</h3>
            <p>{feature.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;
